import Vue from 'vue';
import feathersClient from '../../feathers-client';

const defaultSkillPagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};

const defaultSkillFilter = {
	$skip: defaultSkillPagination.$skip,
	$limit: defaultSkillPagination.$limit,
};

export default {
	namespaced:true,
	state: {
		skills: [],
		skillFilter: defaultSkillFilter,
		skillPagination: defaultSkillPagination,
		groupingTags: [],
		expertLevelTags: [],
	},
	getters: {
		skillPage: (state) => {
			const { $limit, $skip } = state.skillPagination;
			return $skip / $limit + 1;
		},
		skills: (state) => state.skills,
	},
	mutations: {
		SET_SKILLS: (state, skills) => { state.skills = skills; },
		SET_SKILL_FILTER: (state, filter) => { state.skillFilter = { ...state.skillFilter, ...filter }; },
		// eslint-disable-next-line no-shadow
		SET_DEFAULT_SKILL_FILTER: (state, defaultSkillFilter) => { state.skillFilter = defaultSkillFilter; },
		SET_SKILL_PAGINATION: (state, data) => { state.skillPagination = { ...state.skillPagination, ...data }; },
		SET_GROUPING_TAGS: (state, groupingTags) => { state.groupingTags = groupingTags; },
		SET_EXPERT_LEVEL_TAGS: (state, expertLevelTags) => { state.expertLevelTags = expertLevelTags; },
	},
	actions: {
		setSkillFilter: ({ commit }, filter) => {
			commit('SET_SKILL_FILTER', filter);
		},
		setDefaultSkillFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_SKILL_FILTER', filter);
		},
		setSkillPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.skillPagination.$limit;
			commit('SET_SKILL_PAGINATION', { $skip });
			commit('SET_SKILL_FILTER', { $skip });
		},
		searchTags: async ({rootGetters},filter) => {
			const url = '/api/v3/skillgroupingtags'
			const results = await feathersClient.service(url).find({
				query:{
					$role: rootGetters.currentUserRole,
					...filter,
					$paginate:false,
				}
			});
			return results;
		},
		createNewSkill: async ({context,rootGetters}, newSkill) => {
			const url = '/api/v3/skills';
			const results = await feathersClient.service(url).create(newSkill,{
				query:{
					$role: rootGetters.currentUserRole,
				},
			})
			return results;
		},
		loadGroupingTags: async ({ commit,rootGetters }, filter) => {
			const url = '/api/v3/skillgroupingtags'
			const results = await feathersClient.service(url).find({
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			commit('SET_GROUPING_TAGS', results.data);
		},
		loadExpertLevelTags: async ({ commit,rootGetters }, filter) => {
			const url = 'api/v3/skillexpertleveltags'
			const results = await feathersClient.service(url).find({
				query:{
					$role: rootGetters.currentUserRole,
					$paginate:false,
				}
			});
			commit('SET_EXPERT_LEVEL_TAGS', results);
		},
		getSkillById: async ({rootGetters},data) => {
			const id = data.id
			delete data.id
			const url = '/api/v3/skills'
			const results = await feathersClient.service(url).get(id,{
				query:{
					fields:['groupingTags','expertLevelTag'],
					// $role: rootGetters.currentUserRole,
					...data.filter
				}
			})
			return results
		},
		updateSkill: async({rootGetters},skill) => {
			const id= skill.id
			delete skill.id
			const results = await feathersClient.service('/api/v3/skills').patch(id,skill,{
				query:{
					$role:rootGetters.currentUserRole
				}
			});
			return results;
		},
		addBulkSkills: async ({ commit,rootGetters }, data) => {
			const results = await feathersClient.service('/api/v3/skills').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		addBulkTaggedSkillGroups: async ({ rootGetters }, data) => {
			const url = '/api/v3/taggedskillgroups';
			const results = await await feathersClient.service(url).create(data,{
				query:{
					$role:rootGetters.currentUserRole
				}
			});
			return results;
		},
		loadMasterySkills: async ({ commit, rootGetters }, filter) => {
			const url = '/api/v3/getallskills';
			const results = await  feathersClient.service(url).find({
				query:{
					$role: rootGetters.currentUserRole,
					...filter,
				}
			});
			commit('SET_SKILLS', results.data);
			commit('SET_SKILL_PAGINATION', { total: results.total });
		},
		deleteTaggedSkillGroups: async ({ rootGetters }, filter) => {
			const url = '/api/v3/taggedskillgroups';
			const results = await feathersClient.service(url).remove(null,{
				query:{
					$role:rootGetters.currentUserRole,
					...filter,
				}
			});
			return results;
		},
		deleteSkills:async({rootGetters},filter) => {
			const url ='/api/v3/skills';
			const result = await  feathersClient.service(url).remove(null,{
				query:{
					$role: rootGetters.currentUserRole,
					_id:{$in: filter.skills},
				}
			});
			return result
		},
		searchSkill:async({rootGetters},filter) => {
			const url ='/api/v3/skills';
			const result = await  feathersClient.service(url).find({
				query:{
					$role: rootGetters.currentUserRole,
					$search:filter.name,
				}
			});
			return result.data
		}
	},
};
